<template>
    <v-container style="padding-top: 80px;">
        <vue-navigation-bar :options="navbarOptions" @vnb-item-clicked="vnbItemClicked" class="blue darken-4 aki"/>
        <v-row>
            <v-col>
                <router-view></router-view>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    export default {
        title() {
            return this.$route.meta.title
        },
        data: () => ({
            active: 'guide',
            closeOnClick: true,
            perabogado: false,
            permesacontrol: false,
            perrevision: false,
            permiso: 0,
            navbarOptions: {
                elementId: "main-navbar",
                isUsingVueRouter: true,
                mobileBreakpoint: 992,
                brandImagePath: "./",
                collapseButtonOpenColor: "#FFFFFF",
                collapseButtonCloseColor: "#661c23",
                showBrandImageInMobilePopup: true,
                ariaLabelMainNav: "Main Navigation",
                tooltipAnimationType: "shift-away",
                tooltipPlacement: "bottom",
                menuOptionsLeft: []
            },

        }),
        computed: {
            ...mapState(['domain', 'informationPage']),
        },
        methods: {
            vnbItemClicked (text) {
                switch (text) {
                    case "Reportes pendientes":
                        this.$router.push({ name: `ReportesAbogado` });
                        break;
                    case "Recepción de Documentos":
                        this.$router.push({ name: `DoctoPendiente` });
                        break;
                    case "Entrega de Documentos":
                        this.$router.push({ name: 'ReportesPendientes' });
                        break;
                    case "Recibir Documentos":
                        this.$router.push({ name: 'DoctoTramite' });
                        break;
                    case "Reporte Pendientes de Validar":
                        this.$router.push({ name: 'ReportePendienteValidar' });
                        break;
                    case "Recibir Documentos por Pagar":
                        this.$router.push({ name: 'DoctoPendienteRecibir' });
                        break;
                    case "Reporte Pendientes de Pagar":
                        this.$router.push({ name: 'ReportesPendientePagar' });
                        break;
                    case "Solicitar factura": 
                       this.$router.push({ name: `SolicitarFactura` });
                        break;
                    case "Enviar Factura":
                        this.$router.push({ name: `EnvioFacturas` });
                        break;
                    case "Verificar facturas":
                        this.$router.push({ name: `ListadoContrarecibo` });
                        break;
                    case "Cargar Archivo":
                        this.$router.push({ name: `CargarRegistros` });
                        break;
                    
                }
            },
        },
        async mounted() {
            let def = [];

            this.navbarOptions.menuOptionsLeft = def;
            
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '336').then(response => {
                if (response.data.length > 0) {
                    def.push({
                        type: "link",
                        text: "Tramitar Pago",
                        arrowColor: "#659CC8",
                        subMenuOptions: [
                            {
                                isLinkAction: true,
                                type: "link",
                                text: "Reportes pendientes", 
                                path: { name: `ReportesAbogado` }
                            },
                            {
                                isLinkAction: true,
                                type: "link",
                                text: "Enviar Factura",
                                path: { name: "EnvioFacturas" },
                            },
                        ]
                    });
                    this.perabogado = true;
                }
            });
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '337').then(response => {
                if (response.data.length > 0) {
                    def.push({
                        type: "link",
                        text: "Mesa de Control",
                        arrowColor: "#659CC8",
                        subMenuOptions: [
                            {
                                isLinkAction: true,
                                type: "link",
                                text: "Recepción de Documentos",   
                                path: { name: `DoctoPendiente` }
                            },
                            {
                                type: "hr",
                            },
                            {
                                isLinkAction: true,
                                type: "link",
                                text: "Entrega de Documentos",
                                arrowColor: "#659CC8",
                                path: { name: `ReportesPendientes` }
                            },
                        ]
                    });
                    this.permesacontrol = true;
                }
            });
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '338').then(response => {
                if (response.data.length > 0) {
                    def.push({
                        type: "link",
                        text: "Revisión Supervisor",
                        arrowColor: "#659CC8",
                        subMenuOptions: [
                            {
                                isLinkAction: true,
                                type: "link",
                                text: "Recibir Documentos",
                                path: { name: `DoctoTramite` },
                            },
                            {
                                isLinkAction: true,
                                type: "link",
                                text: "Reporte Pendientes de Validar",
                                arrowColor: "#659CC8",
                                path: {name: `ReportePendienteValidar`},
                            }
                        ]
                    });
                    
                    this.perrevision = true;
                }
            });
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '339').then(response => {
                if (response.data.length > 0) {
                    
                    def.push({
                        type: "link",
                        text: "Revisión Contraloría",
                        arrowColor: "#659CC8",
                        subMenuOptions: [
                            {
                                isLinkAction: true,
                                type: "link",
                                text: "Recibir Documentos por Pagar",
                                path: { name: `DoctoPendienteRecibir` },
                            },
                            {
                                isLinkAction: true,
                                type: "link",
                                text: "Reporte Pendientes de Pagar",
                                arrowColor: "#659CC8",
                                path: { name: `ReportesPendientePagar` },
                            },
                            {
                                isLinkAction: true,
                                type: "link",
                                text: "Verificar facturas",
                                arrowColor: "#659CC8",
                                path: { name: `ListadoContrarecibo` },
                            },
                        ]
                    });
                }
            });
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '361').then(response => {
                if (response.data.length > 0) {
                    def.push({
                        type: "link",
                        text: "GNP",
                        arrowColor: "#659CC8",
                        subMenuOptions: [
                            {
                                isLinkAction: true,
                                type: "link",
                                text: "Cargar Archivo",
                                path: { name: `CargarRegistros` },
                            },
                        ]
                    });
                }
            });
        }
    }
</script>
<style>
    .vnb__menu-options__option__link {
        cursor: pointer;
        font-weight: 500;
        color: #f9f5f5 !important;
        transition: color 0.2s ease-in;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 1.1rem !important;
    }

    .vnb__popup__bottom__menu-options__option__link--no-highlight {
        padding: 12px 24px 6px;
        font-weight: 400;
        font-size: 1.0rem !important;
        color: #757575;
    }
    .vnb__collapse-button__image {
        max-height: 30px;
        max-width: 30px;
        color: white !important;
    }
</style>